import { Application } from '@hotwired/stimulus'
import { definitionsFromContext } from '@hotwired/stimulus-webpack-helpers'
import { application } from "../application"

const context = require.context('controllers/app', true, /.js$/)
application.load(definitionsFromContext(context))

import { Toggle } from 'stimulus-yafoy'
application.register('toggle', Toggle)
